import { useEffect, useState } from "react";
import { useReportLogs } from "./api";
import DataLoading from "../../components/DataLoading";
import LogsTable from "./LogsTable";

const List = ({ id }: { id: string }) => {
  const [logsData, setLogsData] = useState<any>([]);
  const { reportLogs, isReportLogsLoading } = useReportLogs(id);
  // console.log({ reportLogs, isReportLogsLoading });
  useEffect(() => {
    if (reportLogs?.length > 0) {
      setLogsData(
        reportLogs?.map((e: any, i: number) => {
          return { key: i + 1, ...e };
        })
      );
    }
  }, [reportLogs]);
  return (
    <div>
      {isReportLogsLoading ? (
        <DataLoading />
      ) : (
        <div style={{ width: "100%", height: "100%" }}>
          <LogsTable data={logsData} />
        </div>
      )}
    </div>
  );
};

export default List;
